import { Menu, MenuItem } from '@fountain/fountain-ui-components';
import { show } from '@intercom/messenger-js-sdk';
import { Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { REACT_APP_MONOLITH_BASE_URL } from 'runtimeEnvVars';

import { IntercomMessenger } from 'components/IntercomMessenger';
import { makeIsWorkrampHelpCenterSSOEnabled } from 'containers/Auth_old/selectors';
import HelpSvg from 'images/HelpSvg';

import messages from './messages';
import useStyles from './styles';

export default function HelpMenu() {
  const classes = useStyles();
  const isWorkrampHelpCenterSSOEnabled = useSelector(
    makeIsWorkrampHelpCenterSSOEnabled(),
  );

  return (
    <>
      <IntercomMessenger />
      <Menu
        id="help-menu"
        className={classes.button}
        MenuListProps={{ className: classes.menuList }}
        triggerEl={<HelpSvg />}
        triggerType="icon"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: -5, horizontal: 'left' }}
        closeOnClick
        defaultIconColor
      >
        <MenuItem
          isExternalLink
          target="_blank"
          href="https://support.fountain.com/"
          className={classes.menuListItem}
        >
          <Typography variant="body2" color="textPrimary">
            <FormattedMessage {...messages.helpCenter} />
          </Typography>
        </MenuItem>
        {isWorkrampHelpCenterSSOEnabled && (
          <MenuItem
            isExternalLink
            target="_blank"
            href={`${REACT_APP_MONOLITH_BASE_URL}/academy_login`}
            className={classes.menuListItem}
          >
            <Typography variant="body2" color="textPrimary">
              <FormattedMessage {...messages.fountainAcademy} />
            </Typography>
          </MenuItem>
        )}
        <MenuItem onClick={show} className={classes.menuListItem}>
          <Typography variant="body2" color="textPrimary">
            <FormattedMessage {...messages.contactSupport} />
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
